import { Box, Button, useTheme } from '@material-ui/core';
import { PiDownloadSimple, PiFilePdf, PiSparkleBold } from 'react-icons/pi';

type Props = {
  isMobile: boolean;
  onExportPdf: () => void;
  onDownloadDocs?: () => void;
  isDownloadingDocs?: boolean;
  onOpenAnalytics?: () => void;
};

export const FormSummaryToolbar = ({
  isMobile,
  onExportPdf,
  onDownloadDocs,
  isDownloadingDocs,
  onOpenAnalytics,
}: Props) => {
  const theme = useTheme();

  return (
    <Box
      className="no-print"
      style={{
        position: 'absolute',
        top: isMobile ? 0 : 24,
        right: isMobile ? 0 : 24,
        left: isMobile ? 0 : 'auto',
        display: 'flex',
        flexDirection: isMobile ? 'row' : 'column',
        flexWrap: 'wrap',
        gap: 8,
        alignItems: isMobile ? 'stretch' : 'flex-end',
        justifyContent: 'flex-end',
        zIndex: 1,
      }}
    >
      <Button
        onClick={onExportPdf}
        variant="outlined"
        startIcon={<PiFilePdf color={theme.palette.primary.main} size={21} />}
        style={{ width: 160 }}
      >
        Export PDF
      </Button>
      {onDownloadDocs && (
        <Button
          onClick={onDownloadDocs}
          disabled={isDownloadingDocs}
          variant="outlined"
          startIcon={<PiDownloadSimple color={theme.palette.primary.main} size={21} />}
          style={{ minWidth: 200, whiteSpace: 'nowrap' }}>
          {isDownloadingDocs ? 'Downloading…' : 'Download Form docs'}
        </Button>
      )}
      {onOpenAnalytics && (
        <Button
          onClick={onOpenAnalytics}
          variant="outlined"
          startIcon={<PiSparkleBold color={theme.palette.primary.main} size={21} />}
          style={{ width: 160 }}
        >
          View Analytics
        </Button>
      )}
    </Box>
  );
};
